
const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-settings-3-line',
      title: '現場課題に即した自動化設計',
      description: '業務フローを詳細にヒアリングし、現場の実情に合わせた最適な自動化ソリューションを設計します。丁寧なヒアリングと高精度な設計を重視しています。',
      image: 'https://public.readdy.ai/ai/img_res/42eaad48c31b63ac8dbb788b73a7f2f8.jpg'
    },
    {
      icon: 'ri-building-line',
      title: '中小企業から個人事業主まで幅広く対応',
      description: '規模を問わず、様々な業界・業種での導入を進めています。お客様のニーズに合わせた柔軟な対応が可能です。',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20business%20companies%20from%20small%20to%20large%20enterprises%2C%20corporate%20buildings%20and%20office%20environments%20representing%20various%20industries%2C%20professional%20business%20growth%20concept%20with%20blue%20and%20white%20color%20scheme&width=400&height=300&seq=feature2&orientation=landscape'
    },
    {
      icon: 'ri-repeat-line',
      title: '継続的なサポートと高い満足度',
      description: '高品質なサービスと継続的なサポートにより、多くのお客様に継続してご利用いただいています。',
      image: 'https://readdy.ai/api/search-image?query=Customer%20satisfaction%20and%20loyalty%20concept%20with%20happy%20business%20professionals%2C%20success%20metrics%20and%20positive%20feedback%20visualization%2C%20clean%20corporate%20environment%20with%20blue%20and%20white%20design%20elements&width=400&height=300&seq=feature3&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Autocroveの<span className="text-blue-600">特徴</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            豊富な実績と高い技術力で、お客様の業務効率化を強力にサポートします
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="mb-6">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
                  <i className={`${feature.icon} text-2xl text-blue-600`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-center">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-xl p-8 shadow-lg">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">複数社</div>
              <div className="text-gray-600">導入実績</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-red-500 mb-2">90%</div>
              <div className="text-gray-600">最大工数削減率</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-600 mb-2">1-2週間</div>
              <div className="text-gray-600">初回提案スピード</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-purple-600 mb-2">幅広い</div>
              <div className="text-gray-600">ツール対応</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
